module.exports = __webpack_public_path__ + "img/house-img4.74140fd8.jpg";